import BaseFormItem from "../BaseFormItem";
import { descriptorPropTypes } from "lib/common/descriptorcontrols/formhelpers";
import Control from "lib/common/descriptorcontrols/Widget/button";
import React from "react";
import PropTypes from "prop-types";
import WidgetActions from "data/WidgetActions";
import Dispatcher from "Dispatcher";

export class Widgetbutton extends BaseFormItem {

    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    onClick(e, d, v) {
        const { fluxContext, descriptor} = this.props;
        Dispatcher.contextDispatch(fluxContext, {
            type: WidgetActions.WIDGET_CLICK,
            config: descriptor.config,
        });
    }

    render() {
        const {activeRecord, descriptor} = this.props;
        return <Control {...this.getPlumbingProps()}
                        onClick={this.onClick}
                        onFocus={undefined}
                        onBlur={undefined}
                        enabled={!descriptor.boundTo || activeRecord.isFieldEnabled(descriptor.boundTo)}
        />;
    }

}

Widgetbutton.propTypes = {
    ...Widgetbutton.propTypes,
    fluxContext: PropTypes.string.isRequired,
    descriptor: PropTypes.shape(descriptorPropTypes(null, false)),
};

export default Widgetbutton;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/Widget/button.js